import https from "./https.js"
import { getFormData } from "@/utils/index.js"
/**
 * 
 * @param {*} method 方法
 * @param {*} url 路径
 * @param {*} data 传给后端的数据
 * @param {*} isFormData  是否需要转换为formData
 * @param {*} headers 需要传的头部数据
 * @param {*} hideTip 隐藏错误提示 false和true
 * @param {*} allRes 为true的话返回整个接口数据，为false的话，默认返回的是res.data
 * @returns   
 */
function request(method,url,data,isFormData,headers,hideTip,allRes) {
  if(isFormData){
      data = getFormData(data)
  }
  if( method === 'get'){
    return https({
      method,
      url,
      params:data,
      headers:isFormData?{ 'Content-Type': 'multipart/form-data',...headers }:{'Content-Type': 'application/json',...headers}, //给接口添加请求}
      hideTip,
      allRes
    })
  }else{
    return https({
      method,
      url,
      data,
      headers:isFormData?{ 'Content-Type': 'multipart/form-data',...headers }:{'Content-Type': 'application/json',...headers}, //给接口添加请求}
      hideTip,
      allRes
    })
  }
}
export let Get = (url, data,isFormData, headers,hideTip,allRes)=> {
  return request('get', url, data,isFormData, headers,hideTip,allRes)
}
export let Post = (url, data,isFormData, headers,hideTip,allRes)=> {
  return request('post', url, data,isFormData, headers,hideTip,allRes)
}
export let Put = (url, data,isFormData, headers,hideTip,allRes)=> {
  return request('put', url, data,isFormData, headers,hideTip,allRes)
}
export let Delete = (url, data,isFormData, headers,hideTip,allRes)=> {
  return request('delete', url, data,isFormData, headers,hideTip,allRes)
}
